import { useDispatch } from 'react-redux';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { setForecastCategory } from '../../../actions/WizardActions';
import { RENAME_CATEGORY_ONBOARDING } from '../../../constants/Events';
import { DEFAULT_CATEGORIES_EDITABLE, DEFAULT_CATEGORIES_NOT_EDITABLE } from '../../../constants/ForecastCategories';
import { trackWizardInteraction } from '../../../utils/usageTracker';
import { isInputEmpty } from '../../../utils/wizardUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CustomizeForecastCategoriesTableRow = ({
  duplicateForecastCategoryLabels,
  referencedCategories,
  forecastCategoryKey,
  forecastCategory,
  categoryDefinition,
  selectedRows,
  setSelectedRows
}) => {
  const dispatch = useDispatch();
  const isEmpty = isInputEmpty(forecastCategory);
  const isDuplicate = duplicateForecastCategoryLabels.includes(forecastCategory.toLowerCase());
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(Checkbox, {
        "aria-label": "Toggle selection for this row",
        "data-test-id": 'forecast-category-row-select',
        disabled: DEFAULT_CATEGORIES_NOT_EDITABLE.includes(forecastCategoryKey),
        checked: selectedRows.includes(forecastCategoryKey),
        onChange: () => {
          if (selectedRows.includes(forecastCategoryKey)) {
            const newSelectedRows = [...selectedRows].filter(row => row !== forecastCategoryKey);
            setSelectedRows(newSelectedRows);
          } else {
            setSelectedRows([...selectedRows, forecastCategoryKey]);
          }
        }
      })
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(UIFormControl, {
        error: isEmpty || isDuplicate,
        validationMessage: /*#__PURE__*/_jsxs(_Fragment, {
          children: [isEmpty && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "wizard.customize.table.forecastCategories.emptyErrorMessage",
            options: {
              forecastCategory
            }
          }), !isEmpty && isDuplicate && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "wizard.customize.table.forecastCategories.duplicateErrorMessage",
            options: {
              forecastCategory
            }
          })]
        }),
        children: /*#__PURE__*/_jsx(UITextInput, {
          "data-test-id": 'forecast-category-input',
          value: forecastCategory,
          error: isDuplicate,
          onChange: e => {
            trackWizardInteraction('customize-categories', RENAME_CATEGORY_ONBOARDING);

            // Forecast Category Key (aka internal value for the property)
            // controls if we show a description since that isn't stored.
            // If the user renames a default category that isn't used, then
            // we will create a new category that doesn't have default description associated
            if (DEFAULT_CATEGORIES_EDITABLE.includes(forecastCategoryKey) && !referencedCategories.includes(forecastCategoryKey)) {
              // update stored forecast categories
              dispatch(setForecastCategory(forecastCategoryKey, e.target.value, '', true));
            } else {
              dispatch(setForecastCategory(forecastCategoryKey, e.target.value, categoryDefinition));
            }
          },
          placeholder: forecastCategory,
          readOnly: DEFAULT_CATEGORIES_NOT_EDITABLE.includes(forecastCategoryKey)
        })
      })
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(UITruncateString, {
        useFlex: true,
        children: categoryDefinition
      })
    })]
  });
};
export default CustomizeForecastCategoriesTableRow;